import Fuse from 'fuse.js';
import { handleActions } from 'redux-actions';
import { getAllAffiliates } from '../../api';
import { createNSActions, updateStateReducer } from '../../utils/redux';

const searchOptions = {
  threshold: 0.2,
  keys: [
    'attributes.name',
    'attributes.short_name',
    'attributes.friendly_id',
  ],
};

const ns = createNSActions('VIEWS.AFFILIATES', null, [
  'LOAD_START',
  'LOAD_FINISH',
  'SET_FILTER',
  'POPULATE_PREV_SELECTED',
]);

const actions = ns.views.affiliates;

const defaultState = {
  isLoading: false,
  affiliates: [],
  filteredAffiliates: [],
  searchIndex: null,
  filterPhrase: null,
};

export const reducer = handleActions({
  [actions.loadStart]: updateStateReducer,
  [actions.loadFinish]: updateStateReducer,
  [actions.setFilter]: updateStateReducer,
}, defaultState);

export const searchBy = phrase =>
  (dispatch, getState) => {
    const { views: { affiliates: state } } = getState();
    const { searchIndex, affiliates } = state;

    if (!phrase) {
      return dispatch(actions.setFilter({
        filterPhrase: null,
        filteredAffiliates: affiliates,
      }));
    }

    return dispatch(actions.setFilter({
      filterPhrase: phrase,
      filteredAffiliates: searchIndex ? searchIndex.search(phrase) : [],
    }));
  };

export const loadAffiliates = () =>
  (dispatch, getState) => {
    const {
      affiliates: initialAffiliates,
    } = getState().views.affiliates;

    dispatch(actions.loadStart({
      isLoading: true,
      filterPhrase: '',
      filteredAffiliates: initialAffiliates,
      searchIndex: new Fuse(initialAffiliates, searchOptions),
    }));

    return getAllAffiliates()
      .then((affiliates) => {
        const {
          filterPhrase: phrase,
        } = getState().views.affiliates;

        dispatch(actions.loadFinish({
          isLoading: false,
          affiliates,
          filteredAffiliates: affiliates,
          searchIndex: new Fuse(affiliates, searchOptions),
        }));

        dispatch(searchBy(phrase));
      });
  };



// WEBPACK FOOTER //
// ./src/views/affiliates/AffiliateState.js